type WidgetSize = { width: number; height: number };

/**
 * A dashboard widget content area is "compact" when it is small in *either*
 * dimension. Below these thresholds the filter pills are floated out of flow so
 * the chart reclaims the space — which both keeps the pills usable on narrow
 * widgets (RSP-4068) and stops the donut chart's count label from being
 * squeezed into the chart on short widgets (RSP-4069). Tunable.
 */
export const COMPACT_WIDGET_WIDTH = 320;
export const COMPACT_WIDGET_HEIGHT = 260;

/**
 * Whether a widget should render in its compact (floated-filter) layout.
 * Returns `false` for an unmeasured size so widgets default to the inline
 * layout until their real size is known (no flash of the collapsed control).
 */
export const isWidgetCompact = (size: WidgetSize | undefined): boolean =>
  size !== undefined &&
  (size.width < COMPACT_WIDGET_WIDTH || size.height < COMPACT_WIDGET_HEIGHT);
